import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ContactListData,
  GenesysContactData,
} from '@shared/interfaces/CallLog';
import { UrlBuilder } from 'http-url-builder';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DialerApiService {
  public baseUrl: UrlBuilder = new UrlBuilder(environment.apim.baseUrl);

  constructor(private readonly http: HttpClient) {}

  fetchContactList(
    contactListData: ContactListData
  ): Observable<GenesysContactData> {
    const url = this.baseUrl
      .addPath('smsdialler')
      .addPath('api')
      .addPath('calldialler')
      .addPath('contact-details')
      .addPath(contactListData.contactListId)
      .addPath(contactListData.contactId)
      .build();
    return this.http.get<GenesysContactData>(url);
  }
}
